import { ForwardRefExoticComponent, PropsWithoutRef, RefAttributes } from 'react';

import { Event } from '~utils/a11y';

import MaterialWrapper from '../material-input-wrapper/materialInputWrapper';

interface Props {
	id?: string;
	type?: string;
	isSearchable?: boolean | undefined;
	value: number | string | boolean | undefined;
	className?: string;
	onChange?: (option: unknown) => void;
	label?: string;
	focusedLabel?: string;
	isInline?: boolean;
	onBlur?: (option: unknown) => void;
	error?: string | null;
	showErrorText?: boolean;
	prefix?: JSX.Element | string;
	suffix?: JSX.Element | string;
	hideSuffixOnBlur?: boolean;
	maxLength?: number;
	readOnly?: boolean;
	inputClassName?: string;
	placeholder?: string;
	onFocus?: (option: unknown) => void;
	autoFocus?: boolean;
	disabled?: boolean;
	onKeyPress?: (event: Event) => void;
	required?: boolean;
}

export default MaterialWrapper('input') as ForwardRefExoticComponent<
	PropsWithoutRef<Props> & RefAttributes<unknown>
>;
